// extracted by mini-css-extract-plugin
export default {"chip":"chip__q0tVD","credit":"credit__Lwuez","debit":"debit__XD6kv","corrected":"corrected__esE_P"};